import React from "react";
import PropTypes from "prop-types";
import { FormControl, FormControlLabel, FormHelperText, Checkbox as MaterialCheckbox } from "@mui/material";


const CheckBoxSimple = ({ id, label, fullWidth, required, variant, margin, errors, field, helperText, size, formControlStyle, labelPlacement, ...props }) => (
  <FormControl
    id={id}
    margin={margin}
    size={size}
    variant={variant}
    fullWidth={fullWidth}
    required={required}
    style={{ ...formControlStyle }}>
    <FormControlLabel
      labelPlacement={labelPlacement}
      control={
        <MaterialCheckbox {...props} />
      }
      label={label} />
    <FormHelperText>{errors && errors.hasOwnProperty(id || field) ? errors[id || field] : helperText}</FormHelperText>
  </FormControl>
);

const CheckBoxWithMoreInfo = ({ moreInfo, key, ...props }) => (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }} key={key}>
    <CheckBoxSimple {...props} />
    {moreInfo}
  </div>
)

const defaultProps = {
  variant: 'standard',
  fullWidth: false,
  required: false,
  size: 'medium',
  margin: 'none',
  labelPlacement: 'end',
};

const CheckBox = (props) => {
  if (props.moreInfo)
    return <CheckBoxWithMoreInfo {...defaultProps} {...props} />
  else
    return <CheckBoxSimple {...defaultProps} {...props} />
}

CheckBox.propTypes = {
  moreInfo: PropTypes.node,
};

CheckBox.displayName = "CheckBox";

export default CheckBox;